import EdImage from "./src/index.vue";

/* istanbul ignore next */
EdImage.install = function (Vue) {
  Vue.component(EdImage.name, EdImage)
}

export default EdImage
